import { render, staticRenderFns } from "./listRules.vue?vue&type=template&id=9bb75640&"
import script from "./listRules.vue?vue&type=script&lang=js&"
export * from "./listRules.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports